import React from 'react';
import { Link } from 'react-router-dom';

const clients = [
  {
    id: 1,
    name: 'Big Freedia',
    image: '/images/clients/big-freedia.jpg',
  },
  {
    id: 2,
    name: 'Tank and the Bangas',
    image: '/images/clients/tank-and-the-bangas.jpg',
  },
  {
    id: 3,
    name: 'Dawn Richard',
    image: '/images/clients/DAWN_RICHARD.jpg',
  },
  {
    id: 4,
    name: 'Sweet Crude',
    image: '/images/clients/sweet_crude.png',
  },
  {
    id: 5,
    name: 'Delvon Lamarr Organ Trio',
    image: '/images/clients/DELVON_LAMARR_ORGAN_TRIO.png',
  },
  {
    id: 6,
    name: 'Alexis and the Sanity',
    image: '/images/clients/ALEXIS_AND_THE_SANITY.png',
  },
];

const Clients = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-purple-600 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Clients
          </h1>
          <p className="text-lg text-purple-100 max-w-2xl mx-auto">
            We're proud to work with incredible artists and creators from around the world.
          </p>
        </div>
      </section>

      {/* Client Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
            {clients.map((client) => (
              <div
                key={client.id}
                className="group relative aspect-square overflow-hidden rounded-2xl bg-gray-100"
              >
                <img
                  src={client.image}
                  alt={client.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/80 via-purple-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                    <h3 className="text-white font-semibold text-lg md:text-xl">
                      {client.name}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-16 bg-mint-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <svg className="w-12 h-12 mx-auto text-mint-400 mb-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
          </svg>
          <blockquote className="text-xl md:text-2xl text-gray-700 font-medium">
            "MerchMint transformed how we handle merchandise. Their attention to quality and detail is unmatched. Our fans love the products!"
          </blockquote>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Join Our Growing Family of Artists
          </h2>
          <p className="text-lg text-purple-100 max-w-2xl mx-auto mb-8">
            Ready to see your merchandise come to life? Let's create something amazing together.
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-base font-semibold rounded-full text-white hover:bg-white hover:text-purple-600 transition-all duration-200"
          >
            Get Started Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Clients;
